import { render, staticRenderFns } from "./OqsSettings.vue?vue&type=template&id=28a72fd8&scoped=true&"
import script from "./OqsSettings.vue?vue&type=script&lang=js&"
export * from "./OqsSettings.vue?vue&type=script&lang=js&"
import style0 from "./OqsSettings.vue?vue&type=style&index=0&id=28a72fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a72fd8",
  null
  
)

export default component.exports